import React, { FunctionComponent, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateGoalStatus } from '../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import useOutsideClick from '../../../../../../utils/click.utils';
import { ITaskMenuProps } from '../TaskMenu/types';

export const TaskStatusMenu: FunctionComponent<ITaskMenuProps> = ({ task }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const changeOpen = useCallback(() => setOpen(!isOpen), [setOpen, isOpen]);
  const close = useCallback(() => setOpen(false), [setOpen]);

  const onChange = (value: string) => {
    dispatch(
      updateGoalStatus(task.id, {
        status: value,
      }),
    );
  };

  const rockStatusOptions = [
    { value: '0', label: 'On Track' },
    { value: '2', label: 'Off Track' },
    { value: '1', label: 'Done' },
    { value: '3', label: 'Incomplete' },
  ];

  const handleClickOutside = () => {
    if (isOpen) {
      setOpen(false);
    }
  };

  const ref = useOutsideClick(handleClickOutside);

  const badgeInfo = useMemo(() => {
    const options = {
      '0': {
        text: 'On Track',
        colorClass: 'lightBlue-bg blue',
      },
      '1': {
        text: (
          <>
            <i className="icon-check"></i> Done
          </>
        ),
        colorClass: 'lightGreen-bg green',
      },
      '2': {
        text: 'Off Track',
        colorClass: 'lightYellow-bg yellow',
      },
      '3': {
        text: 'Incomplete',
        colorClass: 'lightRed-bg red',
      },
      '4': {
        text: 'Overdue',
        colorClass: 'lightRed-bg red',
      },
    };
    return options[task.status];
  }, [task.status]);

  return (
    <div ref={ref}>
      <div className={`card-options dropdown ${isOpen ? 'opened' : ''}`}>
        <ul className="dropdown-menu drop-right pt-2" onClick={close}>
          {rockStatusOptions.map((option) => (
            <li
              key={option.value}
              className="pointer"
              onClick={() => onChange(option.value)}
              style={option.value === task.status ? { opacity: 0.5, cursor: 'default' } : {}}
            >
              <span className="drop-item">{option.label}</span>
            </li>
          ))}
        </ul>
      </div>
      {badgeInfo ? (
        <div className={`badge ${badgeInfo.colorClass} mr-1`} onClick={changeOpen}>
          {badgeInfo.text}
        </div>
      ) : null}
    </div>
  );
};
